import { Link } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { Role } from "@rumble-it/common-lib/types/models/Role.interface";
import { Button } from "@rumbledirect/ui";
import { EyeOutlined } from "@ant-design/icons";

export const roleColumns: ColumnsType<Role> = [
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (name: string, record: Role) => (
      <Link to={`/roles/${record.id}`}>{name}</Link>
    ),
  },
  {
    title: "Pending",
    dataIndex: "pending",
    key: "pending",
    render: (pending: boolean) => (pending ? "Ja" : "Nee"),
  },
  {
    title: "Externe SSO-groep",
    dataIndex: "externalSsoGroup",
    key: "externalSsoGroup",
    render: (externalSsoGroup: string | null) => externalSsoGroup || "-",
  },
  {
    title: "Dealership verplicht",
    dataIndex: "dealershipRequired",
    key: "dealershipRequired",
    render: (dealershipRequired: boolean) =>
      dealershipRequired ? "Ja" : "Nee",
  },
  {
    title: "Systeem",
    dataIndex: "system",
    key: "system",
    render: (system: boolean) => (system ? "Ja" : "Nee"),
  },
  {
    title: "Aantal permissies",
    dataIndex: "permissions",
    key: "permissions",
    render: (permissions: any[]) => permissions?.length || 0,
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/roles/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
